import { FeedbackType } from 'src/api/feedback';

export const labelsByFeedbackType: Record<FeedbackType, string> = {
  [FeedbackType.Question]: 'Вопрос',
  [FeedbackType.Proposal]: 'Предложение',
  [FeedbackType.Issue]: 'Проблема',
};
